import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import staff1 from '../../../../images/staff/member_2.png';

const LeadLimit = ({ show, onClose, data }) => {

    return (
        <Modal show={show} size="md">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Set Lead Limit</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className='d-flex align-items-center justify-content-start gap-4 mb-4'>
                        <div className="d-flex align-items-center">
                            <div className="avatar-preview">
                                <img
                                    id="saveImageFile"
                                    src={data.sales_person_image}
                                    alt={data.sales_person_name}
                                    className='w-100px h-120px'
                                />
                            </div>
                        </div>
                        <div>
                            <label className='fw-bold fs-5 text-black'>{data.sales_person_name}</label>
                            <div className='d-block'>
                                <label className='fw-bold fs-5 text-dark'>{data.sales_person_mobile}</label>
                            </div>
                        </div>
                    </div>
                    <div className='row mb-4'>
                        <div className='col-lg-12'>
                            <label className="text-black font-w500 fs-7">Lead Limit Count <span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Lead Limit Count" />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Set Limit<i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div >
        </Modal >
    );
};

export default LeadLimit;
